
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'AppHeaderV2EvaluationTypeGraph',
  props: {
    hideDashedLine: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('evaluationTypeStatistics', [
      'evaluationTypeStatistics',
      'isLoadingEvaluationTypeStatistics'
    ]),
    ...mapGetters('widget', ['device']),
    maxLengthEvaluationTypeName() {
      return this.evaluationTypeStatistics.reduce(
        (maxName, item) =>
          item.name.length > maxName.length ? item.name : maxName,
        ''
      );
    },
    maxNameWidth() {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const bodyFont = window.getComputedStyle(document.body).fontFamily;
      const fontSize = this.device === 'pc' ? 14 : 12;
      context.font = `${fontSize}px ${bodyFont}`;
      const maxWidth = context.measureText(this.maxLengthEvaluationTypeName)
        .width;

      return `${Math.ceil(maxWidth)}px`;
    },
    evaluationNameStyleProps() {
      return {
        '--evaluation-name-width': this.maxNameWidth
      };
    }
  },
  methods: {
    percentage(options) {
      return Math.round(
        (this.maxCountOption(options).count / this.totalCount(options)) * 100
      );
    },
    totalCount(options) {
      if (!options) return 0;

      return options.reduce((acc, option) => (acc += option.count), 0);
    },
    maxCountOption(options) {
      return options.reduce((max, item) =>
        item.count > max.count ? item : max
      );
    }
  }
};
